<div class="d-flex flex-row-reverse mt-2">
    <div class="form-group mb-0">
        <button class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="NewRole(content)">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Agregar rol
        </button>
    </div>
</div>
<div class="flex-container mt-3">
    <div cdkDropListGroup class="row">
        <div class="col pr-4">
            <h5>Roles</h5>
            <ul class="list-group">
                <li *ngFor="let role of roles" type="button" [ngClass]="{'active' : active(role)}" class="list-group-item list-group-item-action d-flex" (click)="updateRoleSelection(role)">
                    <div class="mr-2" (click)="EditRole(content, role)">
                        <fa-icon class="fa" icon="edit"></fa-icon>
                    </div> {{role.Name}}
                </li>
            </ul>
        </div>
        <div class="col">
            <h5>Permisos Asignados</h5>
            <div cdkDropList [cdkDropListData]="asigPermissions" class="cdk-list" (cdkDropListDropped)="drop($event)">
                <div class="cdk-box" *ngFor="let permission of asigPermissions" cdkDrag>{{permission.Name}}</div>
            </div>
        </div>
        <div class="col-1 d-flex align-items-center">
            <div>
                <button type="button" class="btn btn-outline-secondary border-0" (click)="setAllPermissions()">
                    <fa-icon class="fa" icon="arrow-left"></fa-icon>
                </button>
                <button type="button" class="btn btn-outline-secondary border-0" (click)="unsetAllPermissions()">
                    <fa-icon class="fa" icon="arrow-right"></fa-icon>
                </button>
            </div>
        </div>
        <div class="col">
            <h5>Permisos Disponibles</h5>
            <div cdkDropList [cdkDropListData]="disPermissions" class="cdk-list" (cdkDropListDropped)="drop($event)">
                <div class="cdk-box" *ngFor="let permission of disPermissions" cdkDrag>{{permission.Name}}</div>
            </div>
        </div>
    </div>
</div>
<!-- Ventana modal-->
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{(RoleForm.controls.Id.value > 0)?'Editar':'Crear'}} rol</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="RoleForm">
            <div class="form-group" hidden>
                <input type="number" class="form-control form-control-sm" formControlName="Id">
            </div>
            <div class="form-group">
                <label for="">Nombre</label>
                <input type="text" class="form-control form-control-sm" formControlName="Name">
            </div>
            <div class="form-group">
                <label for="">Código</label>
                <input type="text" class="form-control form-control-sm" formControlName="Code" [readonly]="RoleForm.controls.Id.value > 0">
            </div>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5);">
                <label class="form-check-label" for="exampleCheck1">Activo</label>
            </div>
        </form>
        <br>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">

                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="StoreRole()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseModal()"><i class="fa fa-times-circle" aria-hidden="true"></i>
                    Cerrar&nbsp;
                </button>
            </div>
        </div>
    </div>
</ng-template>